import TextareaAutogrow from "stimulus-textarea-autogrow";

export default class extends TextareaAutogrow {
  connect() {
    super.connect();
    this.element.classList.add("textarea-autogrow");
  }
}
